const Sorter = (name, direction) => {





    
    const sortByKeyName_asc = (entries, isReverseOrder = false) => {


        if (isReverseOrder) { // ture
            entries.sort((a, b) => b[0].localeCompare(a[0])); // Sorting in reverse order
        } else {
            entries.sort((a, b) => a[0].localeCompare(b[0]));
        }


        return entries;
    }

    const sortByKeyName_desc = (entries, isReverseOrder = true) => {


        if (isReverseOrder) { // ture
            entries.sort((a, b) => b[0].localeCompare(a[0])); // Sorting in reverse order
        } else {
            entries.sort((a, b) => a[0].localeCompare(b[0]));
        }


        return entries;
    }


    const sortByTD_asc = (entries, isReverseOrder = false) => {



        const x = (a, b) => {
            let x = a.toLowerCase();
            let y = b.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        }

        if (isReverseOrder) { // ture
            entries.sort((a, b) => x(b[1].td, a[1].td)); // Sorting by the 'td' property
        } else {
            entries.sort((a, b) => {
                // return a[1].td.localeCompare(b[1].td)
                return x(a[1].td, b[1].td);
            }); // Sorting by the 'td' property
        }



        return entries;
    }

    const sortByTD_desc = (entries, isReverseOrder = true) => {



        const x = (a, b) => {
            let x = a.toLowerCase();
            let y = b.toLowerCase();
            if (x < y) { return -1; }
            if (x > y) { return 1; }
            return 0;
        }

        if (isReverseOrder) { // ture
            entries.sort((a, b) => x(b[1].td, a[1].td)); // Sorting by the 'td' property
        } else {
            entries.sort((a, b) => {
                // return a[1].td.localeCompare(b[1].td)
                return x(a[1].td, b[1].td);
            }); // Sorting by the 'td' property
        }


 

        return entries;
    }

    const sortByLastUpdate_asc = (entries, isReverseOrder = false) => {
       

        if (isReverseOrder) { // ture
            entries.sort((a, b) => a[1].updatedTime - b[1].updatedTime); // Sorting by the 'updatedTime' property
            // entries.sort((a, b) => a[1].lambdaDateTime - b[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
            // entries.sort((a, b) => a[1].ttl - b[1].ttl); // Sorting by the 'ttl' property            
        } else {
            entries.sort((a, b) => b[1].updatedTime - a[1].updatedTime); // Sorting by the 'updatedTime' property
            // entries.sort((a, b) => b[1].lambdaDateTime - a[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
            // entries.sort((a, b) => b[1].ttl - a[1].ttl); // Sorting by the 'ttl' property
        }




        

        return entries;
    }


    const sortByLastUpdate_desc = (entries, isReverseOrder = true) => {
       

        if (isReverseOrder) { // ture
            entries.sort((a, b) => a[1].updatedTime - b[1].updatedTime); // Sorting by the 'updatedTime' property
            // entries.sort((a, b) => a[1].lambdaDateTime - b[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
            // entries.sort((a, b) => a[1].ttl - b[1].ttl); // Sorting by the 'ttl' property            
        } else {
            entries.sort((a, b) => b[1].updatedTime - a[1].updatedTime); // Sorting by the 'updatedTime' property
            // entries.sort((a, b) => b[1].lambdaDateTime - a[1].lambdaDateTime); // Sorting by the 'lambdaDateTime' property
            // entries.sort((a, b) => b[1].ttl - a[1].ttl); // Sorting by the 'ttl' property
        }




        

        return entries;
    }



    switch (name) {
        case "Train ID":
            if (direction === "asc") {
                return sortByKeyName_asc;
            } else {
                return sortByKeyName_desc;
            }
        case "TD":
            if (direction === "asc") {
                return sortByTD_asc;
            } else {
                return sortByTD_desc;
            }
        case "Last Update":
            if (direction === "asc") {
                return sortByLastUpdate_asc;
            } else {
                return sortByLastUpdate_desc;
            }
        default:
            return null;
    }

}

export default Sorter;